import styled from 'styled-components';
import { motion } from 'framer-motion';
import { TERMS_AND_CONDITIONS } from '../../routes/routes';

export const Layout = styled(motion.div)`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  justify-content: center;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.background};
`;

export const Main = styled.div<{ pathname: string }>`
  width: ${({ pathname }) =>
    pathname === TERMS_AND_CONDITIONS ? '1000px' : '500px'};
  margin: 80px auto;
  padding: 40px 30px;
  background: ${({ theme }) => theme.colors.neutral0};
  border-radius: 20px;
  box-shadow: ${({ theme }) => theme.shadows.shadowXS};
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 1450px) {
    margin: 40px auto;
  }

  @media (max-width: 1000px) {
    max-width: calc(100% - 32px);
    padding: 32px 16px 16px 16px;
  }
`;
